module.exports = __webpack_public_path__ + "static/media/WCCE-Color-Logo@2x.26b06c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/WCCE-Color-Logo@2x.png
// module id = 909
// module chunks = 0